var map = {
	"./ady-rob.webp": 70780,
	"./april_13.webp": 25447,
	"./april_13_banner.webp": 76594,
	"./april_14.webp": 25962,
	"./april_14_banner.webp": 14953,
	"./april_18.webp": 23486,
	"./april_18_banner.webp": 74037,
	"./april_27.webp": 19884,
	"./april_27_2.webp": 85173,
	"./april_27_2_banner.webp": 13992,
	"./april_27_3.webp": 80906,
	"./april_27_3_banner.webp": 14185,
	"./april_27_3_banners.webp": 95094,
	"./april_27_4.webp": 46087,
	"./april_27_4_banner.webp": 39250,
	"./april_27_5.webp": 99844,
	"./april_27_5_banner.webp": 45683,
	"./april_27_banner.webp": 72059,
	"./chhandigarh-banner.webp": 13134,
	"./chhandigarh.webp": 32653,
	"./enterprise-banner.webp": 42430,
	"./esa-crs.webp": 50166,
	"./g6-hospitality.webp": 45844,
	"./g6-partnership-banner.webp": 17867,
	"./g6-partnership.webp": 15682,
	"./guesttouch.webp": 40293,
	"./guesttouch_banner.webp": 13752,
	"./hilton.webp": 89800,
	"./hilton1.webp": 73267,
	"./hk-inntopia-front-banner.webp": 37037,
	"./hk-inntopia-tile-banner.webp": 15942,
	"./hk-reached.webp": 40940,
	"./hkcrs-esa-banner.webp": 23678,
	"./ihg-approve-banner.webp": 17341,
	"./ihg-approve.webp": 77280,
	"./ihg-hotel-banner.webp": 57640,
	"./ihg-hotel.webp": 36531,
	"./implements-banner.webp": 98341,
	"./implements.webp": 29992,
	"./livaway.webp": 6355,
	"./livaway_banner.webp": 90582,
	"./oyo-partnership-banner.webp": 80103,
	"./oyo-partnership.webp": 88614,
	"./podcast.webp": 91906,
	"./podcast_banner.webp": 73441,
	"./property_imp.webp": 418,
	"./raitgain.webp": 61117,
	"./rategain.webp": 73907,
	"./rategain_banner.webp": 46806,
	"./redroof-announces.webp": 91138,
	"./redroof-main-banner.webp": 36680,
	"./redroof-outsources.webp": 44576,
	"./sojern.webp": 3829,
	"./sojern_banner.webp": 62472,
	"./vegabond-banner.webp": 56103,
	"./vegabond.webp": 57158
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61345;